import React, { useEffect, useState } from "react";
import { FaCar, FaUserTie, FaRoute } from "react-icons/fa";
import 'bootstrap/dist/css/bootstrap.min.css';
import { BASE_URL } from "../../../Components/Base_url/Base_Url";
// import "./Aboutus.css";

function About() {
    const [About, setAbout] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(`${BASE_URL}/aboutus/`)
            .then((res) => res.json())
            .then((data) => {
                setAbout(data.data || []);
            })
            .catch((err) => console.error("Error fetching About:", err))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div>
            <section className="about-us" id="about-us">
                <div className="container">
                    {About.map((about) => (
                        <div className="about-content" key={about.AboutUs_id}>
                            {/* Image Section */}
                            <div className="about-image">
                                <img src="/Imges/Package/About .png" alt="About Call For Cab" />
                                <div className="experience-badge">
                                    <span className="years">10+</span>
                                    <span className="text">Years of Experience</span>
                                </div>
                            </div>

                            {/* Text Section */}
                            <div className="about-text">
                                <h2 className="section-title" style={{ textAlign: "left" }}>
                                    {/* About Call For Cab */}{about.AboutUs_Top_Line}
                                </h2>
                                <p className="about-subtitle">
                                    {/* Your Trusted Travel Partner Since 2015 */}{about.AboutUs_Home_Description}
                                </p>

                                <p className="about-description">
                                    {/* Call For Cab is a premier transportation and travel service
                                    provider dedicated to offering comfortable, reliable, and
                                    affordable travel solutions. With over a decade of experience in
                                    the industry, we have established ourselves as a trusted name in
                                    transportation services. */}{about.AboutUs_Description}
                                </p>

                                {/* Features */}
                                <div className="about-features">
                                    <div className="about-feature">
                                        <div className="about-feature-icon">
                                            <FaCar />
                                        </div>
                                        <div className="about-feature-text">
                                            <h4>{about.AboutUs_Key_heading_1}</h4>
                                            <p>{about.AboutUs_Key_heading_2}
                                                {/* Well-maintained vehicles for a comfortable journey */}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="about-feature">
                                        <div className="about-feature-icon">
                                            <FaUserTie />
                                        </div>
                                        <div className="about-feature-text">
                                            <h4> {about.AboutUs_Key_Description_1}
                                            </h4>
                                            <p>{about.AboutUs_Key_Description_2}
                                                {/* Experienced and courteous drivers for your safety */}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="about-feature">
                                        <div className="about-feature-icon">
                                            <FaRoute />
                                        </div>
                                        <div className="about-feature-text">
                                            <h4>Customized Tours</h4>
                                            <p>Personalized travel packages to suit your needs</p>
                                        </div>
                                    </div>
                                </div>

                                {/* Button */}

                                <a href="/Aboutus" className="btn btn-outline">
                                    Learn More
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

        </div>
    )
}

export default About